import { render, staticRenderFns } from "./TippClip.vue?vue&type=template&id=60ae63f9&scoped=true&"
import script from "./TippClip.vue?vue&type=script&lang=js&"
export * from "./TippClip.vue?vue&type=script&lang=js&"
import style0 from "./TippClip.vue?vue&type=style&index=0&id=60ae63f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae63f9",
  null
  
)

export default component.exports